"use client";

import { AnimatedSection } from "@/components/ui/animated-section";

interface FaqAnimatedHeaderProps {
  title: string;
  description: string;
}

export function FaqAnimatedHeader({ title, description }: FaqAnimatedHeaderProps) {
  return (
    <AnimatedSection animation="fade-up" delay={0}>
      <header className="max-w-3xl text-left mb-4 md:mb-10">
        <h2 className="text-2xl font-semibold tracking-tight text-foreground md:text-4xl">
          {title}
        </h2>
        <p className="hidden md:block mt-4 text-lg text-muted-foreground">
          {description}
        </p>
      </header>
    </AnimatedSection>
  );
}
